import { render } from "./HeroiconsOutlineExclamation.vue?vue&type=template&id=bed5122a"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineExclamation.vue"]])

export default __exports__